angular.module('property-deal')
    .component('propertyDealItemsAssets', {
        bindings:{
            propertyDealId: '<',
        },
        template: '<div class="bold" ng-if="$ctrl.items.length>0">Lista lokali z obsługi sprzedaży:</div>' +
            '<div ng-repeat="it in $ctrl.items | orderBy: [ \'property.type\', \'property.buildingNumber\', \'property.floor\', \'property.number\']" ng-if="it.property">' +
            '<span ng-if="it.property.buildingNumber" uib-tooltip="Budynek">{{it.property.buildingNumber}}</span>' +
            '<span ng-if="it.property.buildingNumber != null && it.property.number != null">&nbsp;/&nbsp;</span>' +
            '<span class="bold" style="color: #337ab7;" ng-if="it.property.number" uib-tooltip="{{ \'property.type.\' + it.property.type | translate }}">{{it.property.number}}</span>' +
            '<span ng-if="it.property.livingAreaFinal || it.property.livingArea">&nbsp;&nbsp;|&nbsp;&nbsp;{{it.property.livingAreaFinal || it.property.livingArea}}&nbsp;m<sup>2</sup></span>' +
            '</div>',
        controller: function (PropertyDeal) {
            this.$onChanges = () => {
                if(this.propertyDealId == null){
                    this.items = []
                    return
                }

                PropertyDeal.itemsAssets({id: this.propertyDealId}).$promise.then(items => this.items= items)
            }
        }
    })
